const errors = {
  PAE406: {
    title: 'Opa, este link está expirado.',
    description: `Acredito que você demorou mais do que 2 horas para acessar este link. \n\n A Secretaria de Saúde vai avaliar seu caso novamente e entrará em contato conforme a necessidade.`,
  },
}

export default errors;